import { objKeyName } from "helper/utils";

export const UAA_PATH = "/uaa";

export const TRANSLATE_UAA = {
  PERMISSION_CONFIG: `${UAA_PATH}/permission-config`,
  SYSTEM_MANAGEMENT: `${UAA_PATH}/system-management`,
  API_MANAGEMENT: `${UAA_PATH}/api-management`,
  SERVICE: `${UAA_PATH}/service`,
  FEATURE: `${UAA_PATH}/feature`,
  USER: `${UAA_PATH}/user`,
};

export const UAA_CHILDREN_PATH = {
  OVERVIEW: `${UAA_PATH}/overview`,
  HOME: `${UAA_PATH}/home`,
  DETAIL_CHANNEL: `${UAA_PATH}/overview/detail-channel/:id`,
  DETAIL_CHANNEL_UPDATE: `${UAA_PATH}/detail-channel/update/:id`, //approve-request
  DETAIL_CHANNEL_EDIT: `${UAA_PATH}/detail-channel/edit/:id`, //approve-request
  //Register
  REGISTER_CREATE_REQUEST: `${UAA_PATH}/register-channel/create-request`,
  REGISTER_CANCEL_REQUEST: `${UAA_PATH}/register-channel/cancel-request`,
  REGISTER_CANCEL_REQUEST_DETAIL: `${UAA_PATH}/register-channel/cancel-request/:id`,
  REGISTER_APPROVE_REQUEST: `${UAA_PATH}/register-channel/approve-request`,
  REGISTER_APPROVE_REQUEST_APPROVE: `${UAA_PATH}/register-channel/approve-request/:id`,
  //Update
  UPDATE_APPROVE_REQUEST: `${UAA_PATH}/update-channel/approve-request`,
  UPDATE_APPROVE_APPROVE: `${UAA_PATH}/update-channel/approve-request/:id`,
  //Cancel
  CANCEL_APPROVE_REQUEST: `${UAA_PATH}/cancel-channel/approve-request`,
  CANCEL_APPROVE_APPROVE: `${UAA_PATH}/cancel-channel/approve-request/:id`,
  //Manager Sys User
  MANAGE_SYS_USER_LIST: `${UAA_PATH}/channel/manage-sys-user`,
  MANAGE_SYS_USER_CREATE: `${UAA_PATH}/channel/manage-sys-user/create`,
  MANAGE_SYS_USER_UPDATE: `${UAA_PATH}/channel/manage-sys-user/update`,
  MANAGE_SYS_USER_DETAIL: `${UAA_PATH}/channel/manage-sys-user/detail`,
  //Funding Management
  REQUEST_CLEAR_DEBIT_CHANNEL: `${UAA_PATH}/request-clear-debit-channel`,
  DETAIL_REQUEST_CLEAR_DEBIT_CHANNEL: `${UAA_PATH}/request-clear-debit-channel/:id`,
  CREATE_REQUEST_CLEAR_DEBIT_CHANNEL: `${UAA_PATH}/create-request-clear-debit-channel`,
  APPROVE_REQUEST_CLEAR_DEBIT_CHANNEL: `${UAA_PATH}/approve-request-clear-debit-channel`,
  DETAIL_APPROVE_REQUEST_CLEAR_DEBIT_CHANNEL: `${UAA_PATH}/approve-request-clear-debit-channel/:id`,

  FUNDING_REQUEST_CASH: `${UAA_PATH}/request-cash-in`,
  FUNDING_APPROVE_CASH: `${UAA_PATH}/approve-cash-in`,
  DEPOSIT_REQUEST: `${UAA_PATH}/deposit-request`,
  DEPOSIT_REQUEST_ADD: `${UAA_PATH}/deposit-request/add`,
  DEPOSIT_REVIEW: `${UAA_PATH}/deposit-review`,
  DEPOSIT_APPROVE: `${UAA_PATH}/deposit-approve`,

  WITHDRAW_CREATE: `${UAA_PATH}/withdraw-create`,
  WITHDRAW_CREATE_DETAIL: `${UAA_PATH}/withdraw-create/:id`,
  WITHDRAW_CREATE_ADD: `${UAA_PATH}/withdraw-create/add`,
  WITHDRAW_CREATE_EDIT: `${UAA_PATH}/withdraw-create/edit/:id`,
  WITHDRAW_REQUEST: `${UAA_PATH}/withdraw-request`,
  WITHDRAW_REQUEST_ADD: `${UAA_PATH}/withdraw-request/add`,
  WITHDRAW_REQUEST_DETAIL: `${UAA_PATH}/withdraw-request/:id`,
  WITHDRAW_APPROVE: `${UAA_PATH}/withdraw-approve`,
  WITHDRAW_APPROVE_DETAIL: `${UAA_PATH}/withdraw-approve/:id`,

  CASH_IN_REQUEST: `${UAA_PATH}/cash-in-request`,
  CASH_IN_APPROVE: `${UAA_PATH}/cash-in-approve`,
  CASH_IN_CREATE_ADD: `${UAA_PATH}/cash-in-request/add`,
  CASH_IN_REQUEST_DETAIL: `${UAA_PATH}/cash-in-request/:id`,
  CASH_IN_REQUEST_EDIT: `${UAA_PATH}/cash-in-request/edit/:id`,
  CASH_IN_APPROVE_DETAIL: `${UAA_PATH}/cash-in-approve/:id`,

  FUNDING_REQUEST: `${UAA_PATH}/funding-request`,
  FUNDING_REQUEST_DETAIL: `${UAA_PATH}/funding-request/:id`,
  FUNDING_REQUEST_ADD: `${UAA_PATH}/funding-request/add`,
  FUNDING_REQUEST_EDIT: `${UAA_PATH}/funding-request/edit/:id`,
  FUNDING_REVIEW: `${UAA_PATH}/funding-review`,
  FUNDING_REVIEW_DETAIL: `${UAA_PATH}/funding-review/:id`,
  FUNDING_APPROVE: `${UAA_PATH}/funding-approve`,
  FUNDING_APPROVE_DETAIL: `${UAA_PATH}/funding-approve/:id`,

  PAY_COMMISSION_REQUEST: `${UAA_PATH}/pay-commission-request`,
  PAY_COMMISSION_REQUEST_ADD: `${UAA_PATH}/pay-commission-request/add`,
  PAY_COMMISSION_REQUEST_DETAIL: `${UAA_PATH}/pay-commission-request/:id`,
  PAY_COMMISSION_APPROVE: `${UAA_PATH}/pay-commission-approve`,
  PAY_COMMISSION_APPROVE_DETAIL: `${UAA_PATH}/pay-commission-approve/:id`,
  BULK_PAYMENT_REQUEST: `${UAA_PATH}/bulk-payment-request`,
  BULK_PAYMENT_REQUEST_ADD: `${UAA_PATH}/bulk-payment-request/add`,
  BULK_PAYMENT_APPROVE: `${UAA_PATH}/bulk-payment-approve`,
  //Funding Management End

  //Report
  REPORT_CHANNEL: `${UAA_PATH}/report-channel`,
  REPORT_COMMISSION: `${UAA_PATH}/report-commission`,
  REPORT_PERCENTAGE: `${UAA_PATH}/report-percentage`,

  //Paymen
  PAYMENT_BATCH_REQUEST: `${UAA_PATH}/batch-payment-request`,
  PAYMENT_BATCH_REQUEST_ADD: `${UAA_PATH}/batch-payment-request/add`,
  PAYMENT_BATCH_REQUEST_DETAIL: `${UAA_PATH}/batch-payment-request/:id`,
  PAYMENT_BATCH_APPROVE: `${UAA_PATH}/batch-payment-approve`,
  PAYMENT_BATCH_APPROVE_DETAIL: `${UAA_PATH}/batch-payment-approve/:id`,

  //master
  PERMISSION_CONFIG: `${UAA_PATH}/permission-config`,
  CREATE_PERMISSION_CONFIG: `${UAA_PATH}/permission-config/:id`,
  USER_MANAGEMENT: `${UAA_PATH}/user-management`,
  SYSTEM_MANAGEMENT: `${UAA_PATH}/system-management`,
  COMPANY_PERMISSION: `${UAA_PATH}/company-permission`,
  API_MANAGEMENT: `${UAA_PATH}/api-management`,
  SERVICE: `${UAA_PATH}/service`,
  FEATURE: `${UAA_PATH}/feature`,

  //Cancel
  CANCEL_CREATE_REQUEST: `${UAA_PATH}/cancel-channel/create-request`,

  UTILITIES: `${UAA_PATH}/ultilities`,
  ULTILITIES_TRANSACTION: `${UAA_PATH}/ultilities/transaction-history`,
  ULTILITIES_DASHBOARD: `${UAA_PATH}/ultilities/dashboard`,

  //Report
  REPORT_TOTAL_TRANS: `${UAA_PATH}/report/total-transaction`,
  REPORT_EWALLET_COMMISSION_BYDATE: `${UAA_PATH}/report/ewllet-commission-bydate`,
  REPORT_EWALLET_COMMISSION: `${UAA_PATH}/report/ewllet-commission`,
  REPORT_EWALLET_COMMISSION_OBJECT: `${UAA_PATH}/report/ewllet-commission-byobject`,
  REPORT_CHANNELS: `${UAA_PATH}/report-channel`,
  REPORT_CHANNELS_DETAIL: `${UAA_PATH}/report-channel-detail`,
  REPORT_PERCENTAGES: `${UAA_PATH}/report-percentage`,
  REPORT_PERCENTAGES2: `${UAA_PATH}/report-percentage2`,
  REPORT_AGENT_COMMISSION_LIST: `${UAA_PATH}/report-agent-commission-list`,
  REPORT_AGENT_COMMISSION_DETAIL: `${UAA_PATH}/report-agent-commission-detail`,
  REPORT_COMMISSION_LIST: `${UAA_PATH}/report-commission-list`,
  REPORT_COMMISSION_DETAIL: `${UAA_PATH}/report-commission-list-detail`,
  COMMISSION_STAFF_REPORT: `${UAA_PATH}/commission-staff-report`,
  REPORT_TRANSACTION_DETAIL_BYDATE: `${UAA_PATH}/report-transaction-details-bydate`,
};

export const STORAGE = {
  TOKEN: "token",
  REFRESH_TOKEN: "refreshToken",
  USER: "userInformation",
};

export const IMAGE_SIZE_MAX = 5 * 1024 * 1024;
export const IMAGE_SIZE_MAX_10MB = 10 * 1024 * 1024;

export const Option = {
  ALL: "ALL",
  NONE: "NONE",
  SYSTEM: "SYSTEM",
};

export const OptionsALL = [
  { label: objKeyName(Option, Option.ALL), value: Option.ALL },
];

export const CHANNEL_STATE_SEARCH = {
  ACTIVE: 10,
  CANCELLED: -2,
  WAITING_CANCEL: -3,
  LOCK: -4,
};

export const CHANNEL_STATE = {
  "REGISTER_-_PENDING_APPROVAL": 8,
  "REGISTER_-_REJECTED": 11,
  "REGISTER_-_REVIEWED": 12,
  "REGISTER_-_APPROVED": 10,
  "UPDATE_-_PENDING_APPROVAL": 9,
  "UPDATE_-_REJECTED": 14,
  "UPDATE_-_REVIEWED": 15,
  "UPDATE_-_APPROVED": 13,
  "CANCEL_-_PENDING_APPROVAL": 16,
  "CANCEL_-_APPROVED": 17,
  "CANCEL_-_REJECTED": 18,
  "CANCEL_-_REVIEWED": 19,
};

export const TRANSACTION_STATUS = {
  "REGISTER_-_PENDING_APPROVAL": 8,
  "REGISTER_-_REJECTED": 11,
  "REGISTER_-_REVIEWED": 12,
  "UPDATE_-_PENDING_APPROVAL": 9,
  "UPDATE_-_REJECTED": 14,
  "UPDATE_-_REVIEWED": 15,
  RECENTLY_UPDATE: 16,
};

export const CHANNEL_STATE_STRING_CREATE = {
  PENDING_APPROVAL: "REGISTER_PENDING_APPROVAL",
  REJECTED: "REGISTER_REJECTED",
  REVIEWED: "REGISTER_REVIEWED",
  APPROVED: "REGISTER_APPROVED",
};
export const CHANNEL_STATE_STRING_UPDATE = {
  PENDING_APPROVAL: "UPDATE_PENDING_APPROVAL",
  REJECTED: "UPDATE_REJECTED",
  REVIEWED: "UPDATE_REVIEWED",
  APPROVED: "UPDATE_APPROVAL",
};

export const REGISTER_STATUS = [
  CHANNEL_STATE["REGISTER_-_PENDING_APPROVAL"],
  CHANNEL_STATE["REGISTER_-_REJECTED"],
  CHANNEL_STATE["REGISTER_-_REVIEWED"],
];
export const UPDATE_STATUS = [
  CHANNEL_STATE["UPDATE_-_PENDING_APPROVAL"],
  CHANNEL_STATE["UPDATE_-_REVIEWED"],
  // CHANNEL_STATE["UPDATE_-_REJECTED"],
];
export const CANCEL_STATUS = [
  CHANNEL_STATE["CANCEL_-_PENDING_APPROVAL"],
  CHANNEL_STATE["CANCEL_-_REVIEWED"],
];

export const INACTIVE_STATUS = [CHANNEL_STATE["CANCEL_-_APPROVED"]];

export const SORT_CRITERIA = {
  code: "Channel Code",
  name: "Channel Name",
  tier: "Channel Tier",
  updatedAt: "Recent Update",
  createdAt: "Create Time",
  status: "Channel Status",
};

export const TRANSACTION_TYPE = {
  CASH_IN_BANK: "Cash in bank",
  CASH_ON_HAND: "Cash on hand",
};

export const PAYMENT_METHOD = {
  CASH_ON_HAND: "COH",
  CASH_IN_BANK: "CIB",
};

export const PAYMENT_METHOD_NUMBER = {
  CASH_IN_BANK: 1,
  CASH_ON_HAND: 2,
};

export const TRANSACTION_BATCH_STATUS = {
  WAITING_PROCCESS: 1,
  PROCESSING: 2,
  FINISHED: 3,
};

export const ID_TYPE = {
  "CIN/CID": "CIN_CID",
  PASSPORT: "PASSPORT",
  NIF: "NIF",
};

export const APPROVE_STATUS = {
  PENDING_APPROVAL: 9,
  APPROVED: 10,
  REJECTED: 11,
};

export const CLEAR_DEBIT_STATUS = {
  PENDING_APPROVAL: 9,
  APPROVED: 13,
  REJECTED: 14,
};

export const GenderOpions = [
  { label: "male", value: 1 },
  { label: "female", value: 2 },
  { label: "other", value: 3 },
];

export const PREFIX = { USD: "$ " };
export const SUFFIX = { USD: " USD", HTG: " HTG" };

export const OptionsIdType = [
  { label: "electoral-card", value: 1 },
  { label: "bi-card", value: 2 },
  { label: "passport", value: 3 },
];

export const OptionsPaperType = [
  { label: "id_card_front", value: 1 },
  { label: "id_card_back", value: 2 },
  { label: "portrait", value: 4 },
  { label: "contract", value: 5 },
  { label: "business_license", value: 6 },
  { label: "other", value: 7 },
];

export const OptionsPrivilege = [
  { label: "POS", value: 1 },
  { label: "PAYSALE", value: 2 },
  { label: "AIRTIME", value: 4 },
];

export const OptionsCountry = [{ label: "Haiti", value: "HT" }];

export const ACTION_ALLOW = {
  isView: true,
  isEdit: true,
  isCreate: true,
  isRemove: true,
  confirmPending: true,
  confirm: true,
  //etc...
};

export const KEY_ROLE_BIZZ_UAA = "role-current-UAA";
export const CONFIG_OTP = "config-otp";
export const CONFIG_REVIEW = "config-review";

export const TYPE_CONFIG = {
  WITHDRAW_REVIEW: "WITHDRAW_REVIEW",
  OTP_WITHDRAW: "OTP_WITHDRAW",
  OTP_CHANNEL: "OTP_CHANNEL",
  OTP_CASHIN: "OTP_CASHIN",
  OTP_FUNDING: "FUNDING_E_MONEY_OTP",
  CONFIG_BO_APPROVE: "FUNDING_E_MONEY_BO_CONDUCT_REVIEW",
  CONFIG_WITHDRAW_BO_APPROVE: "WITHDRAW_BO_CONDUCT_REVIEW",
  BUSINESS_STAFF: "BUSINESS_STAFF",
  OTP_BATCH_PAYMENT_REQUEST: "OTP_BATCH_PAYMENT_REQUEST",
  REQUIRE_BANK: "REQUIRE_BANK",
  OTP_BATCH_PAYMENT_APPROVE: "OTP_BATCH_PAYMENT_APPROVE",
};

export const CONFIG_STATUS = {
  ON: "ON",
  OFF: "OFF",
};

export const ROLE = {
  ADMIN: "ADMIN",

  HO_STAFF: "HO_STAFF",
  HO_BO: "HO_BO",
  HO_REVIEWER: "HO_REVIEWER",
  HO_FINANCE_BO: "HO_FINANCE_BO",

  SA_EXTERNAL_STAFF: "SA_EXTERNAL_STAFF",
  SA_EXTERNAL_BO: "SA_EXTERNAL_BO",
  SA_EXTERNAL_REVIEWER: "SA_EXTERNAL_REVIEWER",
  SUB_SUPER_AGENT_EXTERNAL: "SUB_SUPER_AGENT_EXTERNAL",

  AGENT_EXTERNAL: "AGENT_EXTERNAL",
  AGENT_IN_SHOP_EXTERNAL: "AGENT_IN_SHOP_EXTERNAL",
  AGENT_KEY_EXTERNAL: "AGENT_KEY_EXTERNAL",

  MD_EXTERNAL_STAFF: "MD_EXTERNAL_STAFF",
  MD_EXTERNAL_REVIEWER: "MD_EXTERNAL_REVIEWER",
  MD_EXTERNAL_BO: "MD_EXTERNAL_BO",
};

export const DEPOSIT_STATUS = {
  PENDING_REVIEW: 9,
  PENDING_APPROVAL: 9,
  APPROVED: 13,
  REJECTED: 14,
  CANCEL_TRANSACTION: 14,
};

export const WITHDRAW_STATUS = {
  GIVEN_MONEY: "GIVEN_MONEY",
  REJECTED: "REJECTED",
  PENDING_REVIEW: "PENDING_REVIEW",
  PENDING_APPROVE: "PENDING_APPROVE",
  CANCELED: "CANCELED",
};

export const WITHDRAW_APPROVE_STATUS = {
  PENDING_APPROVAL: "PENDING_APPROVAL",
  APPROVED: "APPROVED",
  REJECTED: "REJECTED",
  // REJECTED_REVIEW: "REJECTED_REVIEW",
  CANCELED: "CANCELED",
};

export const WITHDRAW_REVIEW_STATUS = {
  PENDING_REVIEW: "PENDING_REVIEW",
  PENDING_APPROVAL: "PENDING_APPROVAL",
  APPROVED: "APPROVED",
  REJECTED: "REJECTED",
  // REJECTED_REVIEW: "REJECTED_REVIEW",
  CANCELED: "CANCELED",
};

export const WITHDRAW_CREATE_STATUS = {
  DRAFT: 13,
  PENDING_REVIEW: 8,
  PENDING_APPROVAL: 9,
  APPROVED: 10,
  REJECTED: 11,
  CANCELED: -2,
};

export const CASH_IN_STATUS = {
  PENDING_APPROVAL: 9,
  APPROVED: 10,
  REJECTED: 11,
  CANCELED: -2,
  DRAFT: 12,
};

export const CASH_IN_APPROVE_STATUS = {
  PENDING_APPROVAL: 9,
  APPROVED: 10,
  REJECTED: 11,
  CANCELED: -2,
  // DRAFT: 12,
};

export const CASH_IN_PAYMENT_METHOD = {
  CASH_IN_BANK: 1,
  CASH_ON_HAND: 2,
};

export const TYPE_TIME = {
  WEEK: "Week",
  MONTH: "Month",
  YEAR: "Year",
};

export const FUNDING_REQUEST_STATUS = {
  DRAFT: 13,
  PENDING_REVIEW: 8,
  PENDING_APPROVAL: 9,
  APPROVED: 10,
  REJECTED: 11,
  CANCELED: -2,
};

export const PAPER_TYPE = {
  ID_CARD_FRONT: 9,
  ID_CARD_BACK: 10,
  PORTRAIT: 11,
  CONTRACT: 2,
  BUSINESS_LICENSE: 12,
  OTHER: 13,
  SHOP_IMAGE: 14,
  CONTRACT_HARD_COPY: 15,
  AGREEMENT_CONTRACT: 2,
};

export const IMAGE_TYPE_NAME = {
  ID_CARD_FRONT: "ID Card Front",
  ID_CARD_BACK: "ID Card Back",
  PORTRAIT: "Portrait",
  AGREEMENT_CONTRACT: "Agreement Contract",
  BUSINESS_LICENSE: "Business License",
  OTHER: "Other",
  SHOP_IMAGE: "Shop Image",
  CONTRACT_HARD_COPY: "Signed Contract hardcopy",
};

export const TYPE_ACTION_WITHDRAW = {
  APPROVE: "APPROVE",
  REJECT: "REJECT",
  SUBMIT: "SUBMIT",
  SAVE: "SAVE",
};

export const STATUS_WITHDRAW = {
  PENDING_REVIEW: "Pending review",
  PENDING_APPROVE: "Pending approve",
  PENDING_APPROVAL: "Pending approval",
  DRAFT: "Draft",
  GIVEN_MONEY: "Given",
  REJECTED: "Rejected",
  CANCELED: "Canceled",
};

export const SCREEN_CASHIN = {
  REQUEST: 1,
  APPROVE: 2,
};

export const TYPE_IMAGE = {
  png: "image/png",
  gif: "image/gif",
  jpeg: "image/jpeg",
  jpg: "image/jpg",
};

export const TYPE_UPLOAD = {
  ACCOUNT: "ACCOUNT",
  TRANSACTION: "TRANSACTION",
};
